// extracted by mini-css-extract-plugin
var _1 = "CarouselModalContent-module__animatedBackground--iAlND";
var _2 = "CarouselModalContent-module__caption--syuPn";
var _3 = "CarouselModalContent-module__controlsContainer--KiwC0";
var _4 = "CarouselModalContent-module__sliderContainer--FHcct";
var _5 = "CarouselModalContent-module__thumbnailBarContainer--KuKw7";
export { _1 as "animatedBackground", _2 as "caption", _3 as "controlsContainer", _4 as "sliderContainer", _5 as "thumbnailBarContainer" }
